import React from 'react';
import PageSection from '../PageSection';
import {Button, Arrow, ScrollToTopWrapper} from './styles';

const onScrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};


const ScrollToTop = ({multiBrand=false}) => {
  return (
    <ScrollToTopWrapper multiBrand={multiBrand} tall center>
      <Button multiBrand={multiBrand} onClick={onScrollToTop} type="button">
        <Arrow multiBrand={multiBrand} />
        Back to Top
      </Button>
    </ScrollToTopWrapper>
  );
};


export default ScrollToTop;